<div class="no-processes" data-skip-target tabindex="-1">
  <mat-icon class="no-processes__icon" fontSet="material-icons-outlined" aria-hidden="true">inventory_2</mat-icon>
  <h1 class="no-processes__title">{{ 'MY_WORK_PERMITS.NO_PROCESSES_AVAILABLE.TITLE' | translate }}</h1>
  <p class="no-processes__message">{{ 'MY_WORK_PERMITS.NO_PROCESSES_AVAILABLE.MESSAGE' | translate }}</p>
</div>
